import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Languages, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { apiErrorText } from '../utils/apiErrorText';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PAIRS = [['label', 'label_pl'], ['help', 'help_pl']];

const emptyPolish = (blocks) => {
  const items = {};
  blocks.forEach((b) => PAIRS.forEach(([en, pl]) => {
    if (b.type !== 'builtin' && String(b[en] || '').trim() && !String(b[pl] || '').trim()) items[`${b.id}|${pl}`] = b[en];
  }));
  return items;
};

/** Suggests Polish captions/help texts from the English ones, filling only empty Polish fields. */
export const IntakeTranslateButton = ({ blocks, onApply, compact = false, testId }) => {
  // onApply receives a merge function (current blocks -> blocks) so edits made while waiting are kept.
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const items = emptyPolish(blocks);
  const n = Object.keys(items).length;
  const run = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/candidate-intake-templates/translate`, { items });
      const tr = r.data.translations || {};
      onApply((current) => current.map((b) => {
        const nb = { ...b };
        PAIRS.forEach(([, pl]) => { const v = tr[`${b.id}|${pl}`]; if (v && !String(nb[pl] || '').trim()) nb[pl] = v; });
        return nb;
      }));
      const done = Object.keys(tr).length;
      if (done) toast.success(t('intakeTemplates.tr.done', { count: done }));
      if (r.data.skipped?.length) toast.warning(t('intakeTemplates.tr.skipped', { count: r.data.skipped.length }));
    } catch (e) { toast.error(apiErrorText(e, t, 'intakeTemplates.tr.failed')); }
    setBusy(false);
  };
  return (
    <Button type="button" size="sm" variant="outline" className={compact ? 'h-7 px-2 text-xs' : 'h-8 text-xs'} disabled={!n || busy}
      onClick={run} title={n ? undefined : t('intakeTemplates.tr.nothing')} data-testid={testId}>
      {busy ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Languages className="h-3.5 w-3.5 mr-1" />}
      {compact ? t('intakeTemplates.tr.block') : t('intakeTemplates.tr.all', { count: n })}
    </Button>
  );
};

export default IntakeTranslateButton;
